//@ts-nocheck
//@ts-ignore
/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { useStore } from '../../../../store/store';
import { remoteConfig } from '../../../../firebase/firebase';
import { ReactComponent as ClockSVG } from '../../../../assets/images/clock.svg';
import { ReactComponent as NextSVG } from '../../../../assets/images/next-btn.svg';
import shrimps from '../../../../assets/images/shrimps.webp';
import tunaSalad from '../../../../assets/images/tuna-salad.webp';
import vegatableSalad from '../../../../assets/images/vegetable-salad.webp';
import chickenFillet from '../../../../assets/images/chicken-fillet.webp';
import { useNav } from 'src/onboarding/hooks/nav';

import styles from './style.module.scss';
import { t } from '@web-solutions/module-localization';
import { useUpsalePurchase } from 'core/upsale/hooks/use-upsale-purchase';
import Analytics from '@web-solutions/module-analytics';
import { useRemoteConfig } from 'core/hooks/use-remote-config';
import { getEarlyAchievableOffset } from 'src/onboarding/helpers/getEarlyAchievableOffset';
import WeightChart from 'src/onboarding/components/ui/graph/Graph';
import GoalGraph from 'src/onboarding/components/ui/goalGraph/Graph';
import Button from 'src/onboarding/components/ui/button/Button';
import { Caption } from 'src/onboarding/components/typography/Caption/Caption';
import FailedPayment from '../failedPaymentPopup';
import SuccessPayment from '../successPaymentPopup';
import { ReactComponent as LoadingIcon } from '../../../../assets/images/loading-white.svg';

const WebUpsaleFifth = () => {
  const { when, weight, idealWeight } = useStore();
  const { onNext } = useNav();

  const { upsaleOffer, skipPosition } = useRemoteConfig();

  const [successPayment, setSuccessPayment] = useState(false);
  const [showCheck, setShowCheck] = useState(false);

  const [failedPayment, setFailedPayment] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false);

  const { handleUpsalePurchase, renderPaymentProcessor } = useUpsalePurchase();

  const handlePurchaseAndProceed = async (recurlyId) => {
    setLoading(true);

    const data = await handleUpsalePurchase({
      recurlyId,
      upsaleName: upsaleOffer.upsaleName,
      isNextStepBlocked: true,
    });

    if (!data) {
      setFailedPayment(true);
      return;
    }

    Analytics.trackEvent('step', 'completed', {
      upsaleID: 'web-upsale-5',
      result: 'upsale_payment',
    });

    gtag('event', 'conversion', {
      send_to: 'AW-17149973324/WBLJCNvSyP0aEMym3_E_',
      value: upsaleOffer.priceAmount,
      currency: 'USD',
      transaction_id: '',
    });

    if (data) {
      setSuccessPayment(true);
      setFailedPayment(false);
      setLoading(false);
    }
  };

  const handleCardClick = async () => {
    if (isProcessing) return;

    setIsProcessing(true);
    try {
      await handlePurchaseAndProceed(upsaleOffer.recurlyId);
    } finally {
      setIsProcessing(false);
    }
  };

  useEffect(() => {
    if (successPayment) {
      document.body.style.overflow = 'hidden';

      const showCheckTimer = setTimeout(() => setShowCheck(true), 500);
      const nextTimer = setTimeout(() => onNext(), 1500);

      return () => {
        clearTimeout(showCheckTimer);
        clearTimeout(nextTimer);
        document.body.style.overflow = '';
      };
    } else if (failedPayment) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
  }, [successPayment, failedPayment]);

  useEffect(() => {
    if (failedPayment) {
      const timer = setTimeout(() => setLoading(false), 1000);
      return () => clearTimeout(timer);
    }
  }, [failedPayment]);

  return (
    <>
      <main className={styles.main}>
        <div onClick={onNext} className={skipPosition === 'left' ? styles.skip : styles.skipRight}>
          {t('onboarding.upsaleThird.skip')}
        </div>
        <h1 className={styles.header}>{t('onboarding.upsaleThird.title')}</h1>

        <div className={styles.content}>
          {renderPaymentProcessor({
            activeProduct: upsaleOffer.product,
            oneTimeRecurlyId: upsaleOffer.recurlyId,
          })}
          <div className={styles.graphContainer}>
            {getEarlyAchievableOffset(when) === null ? (
              <WeightChart
                weightNow={weight.type === 'kg' ? weight.kg : weight.lbs}
                dateWhen={when}
                weightWhen={idealWeight.value}
                unit={weight.type === 'kg' ? 'kg' : 'lbs'}
                styles
              />
            ) : (
              <GoalGraph
                weightNow={weight.type === 'kg' ? weight.kg : weight.lbs}
                targetDate={when}
                differenceDate={getEarlyAchievableOffset(when)}
                targetWeight={idealWeight.value}
                unit={weight.type === 'kg' ? 'kg' : 'lbs'}
                styles
              />
            )}
          </div>

          <div className={styles.meals}>
            <h2 className={styles.mealsHeader}>{t('onboarding.upsaleThird.mealsTitle')}</h2>

            <div className={styles.mealsContainer}>
              {[
                {
                  dishName: t('onboarding.upsaleThird.avokadoDish'),
                  image: shrimps,
                  mealType: t('onboarding.upsaleThird.breakfast'),
                  time: t('onboarding.upsaleThird.breakfastTime'),
                },
                {
                  dishName: t('onboarding.upsaleThird.tunaDish'),
                  image: tunaSalad,
                  mealType: t('onboarding.upsaleThird.lunch'),
                  time: t('onboarding.upsaleThird.lunchTime'),
                },
                {
                  dishName: t('onboarding.upsaleThird.saladDish'),
                  image: vegatableSalad,
                  mealType: t('onboarding.upsaleThird.snack'),
                  time: t('onboarding.upsaleThird.snackTime'),
                },
                {
                  dishName: t('onboarding.upsaleThird.chickenDish'),
                  image: chickenFillet,
                  mealType: t('onboarding.upsaleThird.dinner'),
                  time: t('onboarding.upsaleThird.dinnerTime'),
                },
              ].map((item, idx) => (
                <div className={styles.card} key={idx}>
                  <div className={styles.imgWrapper}>
                    <img src={item.image} alt='img' />
                  </div>

                  <h4 className={styles.cardHeader}>{item.dishName}</h4>
                  <div className={styles.mealDetails}>
                    <span className={styles.mealType}>{item.mealType}</span>
                    <ClockSVG />
                    <span className={styles.mealTime}>{item.time}</span>
                  </div>
                </div>
              ))}
              <div
                className={`${styles.offerCard} ${isProcessing ? styles.processing : ''}`}
                onClick={handleCardClick}
              >
                <h4 className={styles.cardHeader}>{t('onboarding.upsaleThird.offerTitle')}</h4>
                <div className={styles.images}>
                  {[shrimps, tunaSalad, vegatableSalad, chickenFillet].map((src, idx) => (
                    <div className={styles.img}>
                      <img src={src} alt='img' />
                    </div>
                  ))}
                </div>
                <button className={styles.nextBtn}>
                  <NextSVG />
                </button>
              </div>

              {successPayment && (
                <SuccessPayment onClose={() => setSuccessPayment(false)} showCheck={showCheck} />
              )}

              {failedPayment && (
                <FailedPayment
                  onClose={() => setFailedPayment(false)}
                  onRetry={() => handlePurchaseAndProceed(upsaleOffer.recurlyId)}
                  loading={loading}
                />
              )}
            </div>
          </div>
        </div>
      </main>
      <footer className={styles.footer}>
        <Button
          disabled={loading}
          title={loading ? <LoadingIcon /> : t('onboarding.upsaleFifth.continue')}
          onClick={() => handlePurchaseAndProceed(upsaleOffer.recurlyId)}
        />
        <Caption size='s' className={styles.description}>
          {t('onboarding.upsaleFifth.description', { price: upsaleOffer.priceAmount })}
        </Caption>
      </footer>
    </>
  );
};

export default WebUpsaleFifth;
